import { render, staticRenderFns } from "./type.vue?vue&type=template&id=3728504a&scoped=true"
import script from "./type.vue?vue&type=script&lang=ts"
export * from "./type.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3728504a",
  null
  
)

export default component.exports